module.exports = __webpack_public_path__ + "static/media/software-8.a0324d62.jpg";